import React from 'react';
import {
  TextInput,
  IfMobile,
  SelectDatePicker
} from '@youngcapital/component-library';
import PropTypes from 'prop-types';
import i18next from 'i18next';

const ResponsiveDatePicker = ({
  fieldProps,
  label,
  noDays,
  isRequired = true,
  ...rest
}) => (
  <IfMobile
    thenRender={props => <TextInput {...props} type='date' />}
    elseRender={props => (
      <SelectDatePicker
        {...props}
        {...rest}
        locale={i18next.language}
        onChange={e => {
          fieldProps.setValue(e);
          fieldProps.setTouched();
        }}
        noDays={noDays}
      />
    )}
    props={{
      ...fieldProps,
      label,
      isRequired
    }}
  />
);

ResponsiveDatePicker.propTypes = {
  fieldProps: PropTypes.object,
  label: PropTypes.string,
  noDays: PropTypes.bool,
  isRequired: PropTypes.bool
};

export default ResponsiveDatePicker;
